export const HTTP_VERBS = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
    PATCH: 'PATCH',
    HEAD: 'HEAD',
};

const decoratePromiseWithErrors = (promise) =>
    promise.then(
        (response) => {
            if (response.ok) {
                return response;
            }
            return Promise.reject(response);
        },
        (err) => {
            // not an HTTP error, we better have to log that one
            Hop.logError(err);
            throw err;
        },
    );

/**
 * Tiny http client wrapper of the javascript Fetch API
 */
// TODO : handle request and response auto conversion
export class HTTPClient {
    constructor(headers) {
        this.headers = headers;
    }

    get(uri, headers = {}) {
        return decoratePromiseWithErrors(
            fetch(uri, {
                headers: this._mergeHeaders(headers),
                method: HTTP_VERBS.GET,
                credentials: 'same-origin',
            }),
        );
    }

    patch(uri, body, headers = {}) {
        return decoratePromiseWithErrors(
            fetch(uri, {
                body,
                headers: this._mergeHeaders(headers),
                method: HTTP_VERBS.PATCH,
                credentials: 'same-origin',
            }),
        );
    }

    post(uri, body, headers = {}) {
        return decoratePromiseWithErrors(
            fetch(uri, {
                body,
                headers: this._mergeHeaders(headers),
                method: HTTP_VERBS.POST,
                credentials: 'same-origin',
            }),
        );
    }

    put(uri, body, headers = {}) {
        return decoratePromiseWithErrors(
            fetch(uri, {
                body,
                headers: this._mergeHeaders(headers),
                method: HTTP_VERBS.PUT,
                credentials: 'same-origin',
            }),
        );
    }

    delete(uri, headers = {}) {
        return decoratePromiseWithErrors(
            fetch(uri, {
                headers: this._mergeHeaders(headers),
                method: HTTP_VERBS.DELETE,
                credentials: 'same-origin',
            }),
        );
    }

    _mergeHeaders(headers) {
        const commonHeaders = this.headers || {};
        return new Headers(Object.assign({}, commonHeaders, headers));
    }
}

const defaultHttpClient = new HTTPClient();

export function mixin(Hop) {
    Object.assign(Hop, {
        httpClient: (headers) => new HTTPClient(headers),
        get: (uri, headers) => new HTTPClient().get(uri, headers),
        remove: (uri, headers) => new HTTPClient().delete(uri, headers),
        patch: (uri, body, headers) => new HTTPClient().patch(uri, body, headers),
        post: (uri, body, headers) => new HTTPClient().post(uri, body, headers),
        put: (uri, body, headers) => new HTTPClient().put(uri, body, headers),
    });
}

export const httpClient = defaultHttpClient;
